(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationDefinitionDeleteController',CommunicationDefinitionDeleteController);

    CommunicationDefinitionDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationDefinition'];

    function CommunicationDefinitionDeleteController($uibModalInstance, entity, CommunicationDefinition) {
        var vm = this;

        vm.communicationDefinition = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CommunicationDefinition.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
